/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEye: {
  name: 'eye';
  data: string;
} = {
  name: 'eye',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.65 7.812C3.167 4.906 5.74 3.5 8 3.5c2.261 0 4.833 1.406 6.35 4.312a.406.406 0 0 1 0 .376C12.833 11.094 10.26 12.5 8 12.5c-2.261 0-4.833-1.406-6.35-4.312a.406.406 0 0 1 0-.376ZM8 2.5C5.327 2.5 2.434 4.148.764 7.35a1.406 1.406 0 0 0 0 1.3C2.434 11.852 5.327 13.5 8 13.5c2.672 0 5.566-1.648 7.236-4.85a1.406 1.406 0 0 0 0-1.3C13.566 4.148 10.672 2.5 8 2.5ZM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z" fill="currentColor"/></svg>`,
};
